<template>
    <ModalFormCard action="/actions/lead-add-to-existing-contact" class="modal-default wide">
        <template #title>Add lead to existing contact</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="contact_id" :value="selected" />
            <input type="hidden" name="lead_id" :value="editingModel.id" />
            <input type="hidden" name="lead_type" :value="100" />

            <Input
                v-model:value="search"
                boxClass="bg-white border-0 border-b px-3"
                class="sticky top-0 pt-2 bg-white"
                placeholder="Search contacts"
                @keyup="searchContacts"
            >
                <template #left="{ isFocused }">
                    <IconSearch
                        :class="[isFocused ? 'stroke-black' : 'stroke-grey-800']"
                        class="h-6 w-6 shrink-0 transition-colors duration-300"
                    />
                </template>
            </Input>

            <p class="pt-2 text-13 text-grey-900">Search for a contact by first name, last name, address, email or phone number</p>

            <div class="mt-7 lg:h-[340px] overflow-y-scroll -mx-6 border-y border-grey-500">
                <ClientOnly v-if="searching">
                    <div class="h-full flex items-center justify-center">
                        <Vue3Lottie :animationData="ZapoLogoJson" :height="100" :width="100" :loop="true" />
                    </div>
                </ClientOnly>

                <div
                    v-if="!searching"
                    v-for="(contact, ci) in contacts"
                    class="flex hover:cursor-pointer py-4 px-6 hover:bg-grey-300"
                    @click="selected == contact.id ? (selected = null) : (selected = contact.id)"
                    :class="{
                        'border-b border-grey-500': ci != contacts.length - 1,
                    }"
                >
                    <div class="pr-3 pt-px">
                        <InputCheckbox :checked="selected == contact.id" />
                    </div>

                    <div class="shrink-0">
                        <p
                            class="text-15 font-semibold"
                            :class="{
                                'text-grey-900': contact.archived_at != null,
                            }"
                        >
                            {{ contact.first_name != null ? contact.fullName() : $help.e164ToNumber(contact.getPrimaryNumber().value) }}
                        </p>
                        <p class="text-14 text-grey-900 pt-1.5 lg:pt-0 w-fit">
                            {{
                                contact.addressOverview({
                                    addr: true,
                                    town: true,
                                    post: true,
                                })
                            }}
                        </p>

                        <div class="lg:flex flex-wrap block col-span-2 gap-1 w-full mt-2">
                            <div
                                class="pill bg-white"
                                v-if="contact.getPrimaryNumber() != null"
                                :class="[contact.archived_at != null ? '!stroke-grey-800 !text-grey-900' : 'stroke-green-600']"
                            >
                                <IconPhone class="h-4 w-4" />

                                <p class="text-14 pl-1.5 underline lg:no-underline">
                                    {{ $help.e164ToNumber(contact.getPrimaryNumber().value) }}
                                </p>
                            </div>

                            <div
                                class="pill bg-white"
                                v-if="contact.getPrimaryEmail() != null"
                                :class="[contact.archived_at != null ? '!stroke-grey-800 !text-grey-900' : 'stroke-red-600']"
                            >
                                <IconEmail class="h-4 w-4" />
                                <p class="text-14 pl-1.5 underline lg:no-underline">{{ contact.getPrimaryEmail().value }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-buttons">
                <ButtonSaving :disabled="saving || selected == null" class="button-black default h-12">Add to contact</ButtonSaving>

                <button :disabled="saving" class="default button-purple !col-span-1" @click="$emit('close')">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Lead from '~/models/lead.js'
import Contact from '~/models/contact.js'
import Modal from '~/mixins/modal.js'
import ZapoLogoJson from '~/assets/animation-zapo-loading.json'

export default {
    mixins: [Modal],

    created() {
        this.setup(Lead)
    },

    data() {
        return {
            contacts: null,
            selected: null,
            search: '',
            searching: false,
            ZapoLogoJson,
        }
    },

    methods: {
        searchContacts(event) {
            this.$help.delay(() => {
                this.getContacts(this.search)
            }, 600)
        },

        getContacts(search) {
            if (search == '') {
                this.contacts = null
                return false
            }

            this.searching = true

            this.$axios
                .get('/actions/contacts-search', {
                    params: {
                        search: search,
                    },
                })
                .then((res) => {
                    this.contacts = Contact.fill(res.contacts, {
                        vue: this,
                    })

                    this.searching = false
                })
        },
    },

    computed: {},
}
</script>
